import css from './css.module.scss';

const NotFound = () => (<h1 className={css.title}>Page not found</h1>);

export default NotFound;
